import { Drawer, IconButton, Box, Typography, useTheme, Collapse, SwipeableDrawer, Divider, Tooltip } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import React, { useMemo, useState } from 'react'
import { useEffect } from 'react'

import { useLayoutContext } from '../../../../shared/contexts/layout.context'
import { useUserStore } from '../../../store/user.store'
import aliveLogo from '../../../../shared/assets/alivelogo.png'
import CustomSwitch from '../../../../shared/components/common/CustomSwitch'
import { Icons } from '../../../../shared/utils/icons.jsx'

const closedSidebarWidth = 60


export const EcosystemPortalCard = ( { isSideDrawerCollapsed } ) => {
    const theme = useTheme()
    const isDark = theme.palette.mode === 'dark'

    return (
        <Link
            to="/admin/dashboard"
            target="_placements"
            className="default-link"
            style={{ textDecoration: 'none', display: 'block', width: '100%', position: "sticky", bottom: 0 }}
        >
            <Box
                sx={{
                    mb: 1,
                    position: 'sticky',
                    bottom: 0,
                    overflow: 'hidden',
                    borderRadius: 2.5,
                    p: isSideDrawerCollapsed ? 0 : 1,
                    paddingY: isSideDrawerCollapsed ? 0 : 0.5,
                    cursor: 'pointer',
                    width: '100%',

                    background: isDark
                        ? `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[900]} 100%)`
                        : `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.secondary.light} 100%)`,

                    color: theme.palette.text.primary,
                    border: '1px solid transparent',
                    borderColor: isDark
                        ? 'rgba(255, 255, 255, 0.12)'
                        : 'rgba(0, 0, 0, 0.08)',

                    boxShadow: isDark
                        ? '0 4px 20px rgba(0, 0, 0, 0.4)'
                        : '0 4px 20px rgba(0, 0, 0, 0.05)',

                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

                    '&:hover': {
                        transform: 'translateY(-2px)',
                        borderColor: theme.palette.secondary.main,
                        boxShadow: isDark
                            ? `0 8px 25px ${theme.palette.secondary.main}33`
                            : `0 8px 25px ${theme.palette.secondary.main}20`,
                        '& .arrow-icon': {
                            transform: 'translate(3px, -3px)',
                            color: theme.palette.secondary.main,
                            bgcolor: isDark ? 'rgba(255, 255, 255, 0.1)' : theme.palette.action.hover,
                        },
                        '& .bg-glow': {
                            opacity: isDark ? 0.25 : 0.4,
                            transform: 'scale(1.2)',
                        },
                    },
                }}
            >
                {/* Background Glow */}
                <Box
                    className="bg-glow"
                    sx={{
                        position: 'absolute',
                        top: -20,
                        right: -20,
                        width: 100,
                        height: 100,
                        borderRadius: '50%',
                        background: theme.palette.secondary.main,
                        opacity: isDark ? 0.12 : 0.15,
                        filter: 'blur(25px)',
                        transition: 'all 0.5s ease',
                        pointerEvents: 'none',
                    }}
                />

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                    <Box sx={{ width: isSideDrawerCollapsed ? "100%" : "auto", display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        {/* Icon Container */}
                        <Tooltip arrow placement="right" title={isSideDrawerCollapsed ? "Switch to Placements Portal" : ""}>
                            <Box
                                sx={{
                                    width: isSideDrawerCollapsed ? "100%" : "auto",
                                    p: 1.2,
                                    borderRadius: 2,
                                    bgcolor: isDark
                                        ? 'rgba(255, 255, 255, 0.06)'
                                        : 'rgba(0, 0, 0, 0.04)',
                                    color: theme.palette.secondary.main,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {Icons.default.Building1}
                            </Box>
                        </Tooltip>

                        {!isSideDrawerCollapsed && <Box>
                            <Typography
                                noWrap
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 600,
                                    lineHeight: 1.2,
                                    color: theme.palette.text.primary
                                }}
                            >
                                Placements Portal
                            </Typography>
                        </Box>}
                    </Box>

                    {/* Action Icon */}
                    {!isSideDrawerCollapsed && <Box
                        className="arrow-icon"
                        sx={{
                            display: 'inline-flex',
                            p: 0.8,
                            borderRadius: '50%',
                            color: theme.palette.text.secondary,
                            bgcolor: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.3s ease',
                        }}
                    >
                        {Icons.default.ArrowOutward}
                    </Box>}
                </Box>
            </Box>
        </Link>
    )
}

export const allMenu = [
    { id: "cat1", type: "category-header", active: true, label: "General", categoryValue: "general", view: ["left-pannel", "opened-bottom-bar"] },
    { id: "admin-dashboard", type: "link", category: "general", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/admin\/home)\/?$/], label: "Dashboard", icon: Icons.default.HomeIconOutlined, activeIcon: Icons.default.HomeIcon, link: `/admin/home`, children: null, active: true },
    { id: "admin-announcements", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/announcement)\/?$/], active: true, permission: "announcements", label: "Announcements", activeIcon: Icons.default.Announcement, icon: Icons.default.AnnouncementOutlined, link: `/admin/announcement`, children: null },
    { id: "admin-attendance", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/attendance)\/?$/], active: true, permission: "attendance_audit", label: "Online Class Attendance", activeIcon: Icons.default.EmojiPeopleIcon, icon: Icons.default.EmojiPeopleIconOutlined, link: `/admin/attendance`, children: null },
    { id: "admin-resume-builder", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [[/^(\/admin\/resume-forms)\/?$/], [/^(\/admin\/resume-templates)\/?$/], [/^(\/admin\/resume-entities)\/?$/]], active: true, permission: "resume_builder", label: "Resume Builder", icon: Icons.default.ProtraitOutlined, activeIcon: Icons.default.Protrait, link: [`/admin/resume-forms`, `/admin/resume-templates`, `/admin/resume-entities`], children: ["Resume Forms", "Resume Templates", "Resume Entities"], childrenIcons: [{ default: Icons.default.FormOutlined, activeIcon: Icons.default.Form }, { default: Icons.default.TemplatesOutlined, activeIcon: Icons.default.Templates }, { default: Icons.default.EntityOutlined, activeIcon: Icons.default.Entity }] },
    { id: "admin-password", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/password)\/?$/], active: true, label: "Password", icon: Icons.default.LockIconOutlined, activeIcon: Icons.default.LockIcon, link: `/admin/password`, children: null },
    { id: "admin-service-logs", type: "link", category: "general", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/admin\/debug-logs)\/?$/], active: true, permission: "service_logs", label: "Service Logs", icon: Icons.default.TerminalOutlined, activeIcon: Icons.default.Terminal, link: `/admin/debug-logs`, children: null },
    { id: "admin-activity-logs", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/activity-logs)\/?$/], active: true, permission: "admin_permission", label: "Admin Activity Logs", icon: Icons.default.AdminActivityOutlined, activeIcon: Icons.default.AdminActivity, link: `/admin/activity-logs`, children: null },
    { id: "admin-assessments", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/assessment)\/?$/, /^(\/admin\/assessment)\/new\/?$/, /^(\/admin\/assessment)\/\d+\/?$/, /^(\/admin\/assessment)\/\d+\/participation\/?$/, /^(\/admin\/assessment)\/\d+\/evaluate\/\d+\/?$/], active: true, permission: "admission_exams", label: "Pre-Post Assessments", activeIcon: Icons.default.DomailAdd, icon: Icons.default.DomailAdd, link: `/admin/assessment`, children: null },
    { id: "admin-impersonations", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/impersonation)\/?$/], active: true, permission: "admin_permission", label: "Impersonation", activeIcon: Icons.default.Impersonation, icon: Icons.default.ImpersonationOutlined, link: `/admin/impersonation`, children: null },
    { id: "admin-workers", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/job-workers)\/?$/], active: true, permission: "admin_permission", label: "Job Workers", activeIcon: Icons.default.Engineering, icon: Icons.default.EngineeringOutlined, link: `/admin/job-workers`, children: null },
    { id: "audit-upcoming-classes", type: "link", category: "general", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/class-audit)\/?$/], active: true, permission: "auditing", label: "Upcoming classes & meetings", icon: Icons.default.OndemandVideoIconOutlined, activeIcon: Icons.default.OndemandVideoIcon, link: `/admin/class-audit`, children: null },

    { id: "divider-general", type: "divider", active: false, view: ["left-pannel"] },

    { id: "cat-permissions", type: "category-header", active: true, label: "Permissions and Controls", categoryValue: "permissions", view: ["left-pannel", "opened-bottom-bar"] },
    { id: "admin-accounts", type: "link", category: "permissions", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/admin\/accounts)\/?$/], active: true, permission: "admin_permission", label: "Admin Accounts", icon: Icons.default.ManageAccountsOutlined, activeIcon: Icons.default.ManageAccounts, link: `/admin/accounts`, children: null },
    { id: "admin-module-permissions", type: "link", category: "permissions", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/module-permissions)\/?$/], active: true, permission: "admin_permission", label: "Module Permissions", activeIcon: Icons.default.ModulePermissions, icon: Icons.default.ModulePermissionsOutlined, link: `/admin/module-permissions`, children: null },
    { id: "admin-user-permissions", type: "link", category: "permissions", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/user-permissions)\/?$/], active: true, permission: "admin_permission", label: "User Permissions", activeIcon: Icons.default.ModulePermissions, icon: Icons.default.User, link: `/admin/user-permissions`, children: null },
    { id: "admin-control-panel", type: "link", category: "permissions", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/control-panel)\/?$/], active: true, permission: "control_panel", label: "Control Panel", icon: Icons.default.SettingsOutlined, activeIcon: Icons.default.Settings, link: `/admin/control-panel`, children: null },

    { id: "divider-permissions", type: "divider", active: false, view: ["left-pannel"] },

    { id: "cat-audit", type: "category-header", active: true, label: "Resource Auditing", categoryValue: "audit", view: ["left-pannel", "opened-bottom-bar"] },
    { id: "audit-dashboard", active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/audit)\/?$/], permission: "auditing", label: "Resource Analytics", children: null, link: `/admin/audit`, icon: Icons.default.AnalyticsIconOutlined, activeIcon: Icons.default.AnalyticsIcon },
    { id: "audit-simba-ai", type: "link", category: "audit", active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/practice-with-simba)\/?$/, /^(\/admin\/practice-with-simba)\/list\/?$/, /^(\/admin\/practice-with-simba)\/issues\/?$/], permission: "auditing", label: "Practice sessions with Simba", children: null, link: "/admin/practice-with-simba", activeIcon: Icons.default.Checklist, icon: Icons.default.Checklist },
    { id: "audit-assignments", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/assignments)\/?$/, /^(\/admin\/assignments)\/list\/?$/], active: true, permission: "auditing", label: "Assignments", icon: Icons.default.DescriptionIcon, activeIcon: Icons.default.DescriptionIconOutlined, link: `/admin/assignments`, children: null },
    { id: "audit-online-classes", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/online-classes)\/?$/, /^(\/admin\/online-classes)\/list\/?$/, /^(\/admin\/online-classes)\/[-\w]+\/?$/], active: true, permission: "auditing", label: "Online Classes", icon: Icons.default.SchoolOutlined, activeIcon: Icons.default.School, link: `/admin/online-classes`, children: null },
    { id: "audit-hybrid-classes", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/hybrid-classes)\/?$/, /^(\/admin\/hybrid-classes)\/list\/?$/, /^(\/admin\/hybrid-classes)\/[-\w]+\/?$/], active: true, permission: "auditing", label: "Hybrid Classes", icon: Icons.default.HybridClassesOutlined, activeIcon: Icons.default.HybridClasses, link: `/admin/hybrid-classes`, children: null },
    { id: "audit-meetings", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/meetings)\/?$/, /^(\/admin\/meetings)\/list\/?$/, /^(\/admin\/meetings)\/[-\w]+\/?$/], active: true, permission: "auditing", label: "Webinar and meetings", icon: Icons.default.MeetingRoomsOutlined, activeIcon: Icons.default.MeetingRooms, link: `/admin/meetings`, children: null },
    { id: "audit-exams", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/exams)\/?$/, /^(\/admin\/exams)\/list\/?$/, /^(\/admin\/exams)\/\w+\/?$/], active: true, permission: "auditing", label: "Exams", icon: Icons.default.QuizIconOutlined, activeIcon: Icons.default.QuizIcon, link: `/admin/exams`, children: null },
    { id: "audit-study-materials", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/study-materials)\/?$/, /^(\/admin\/study-materials)\/list\/?$/], active: true, permission: "auditing", label: "Study Materials", icon: Icons.default.DescriptionIconOutlined, activeIcon: Icons.default.DescriptionIcon, link: `/admin/study-materials`, children: null },
    { id: "audit-quizzes", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/quizzes)\/?$/, /^(\/admin\/quizzes)\/list\/?$/], active: true, permission: "auditing", label: "Quizzes", icon: Icons.default.QuizIconOutlined, activeIcon: Icons.default.QuizIcon, link: `/admin/quizzes`, children: null },
    { id: "audit-questionbanks", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/questionbanks)\/?$/, /^(\/admin\/questionbanks)\/list\/?$/], active: true, permission: "auditing", label: "Question Banks", icon: Icons.default.QuestionMarkOutlined, activeIcon: Icons.default.QuestionMark, link: `/admin/questionbanks`, children: null },
    { id: "audit-class-sessions", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/class-sessions)\/?$/, /^(\/admin\/class-sessions)\/list\/?$/], active: true, permission: "auditing", label: "Beyond class resources", icon: Icons.default.EmojiPeopleIconOutlined, activeIcon: Icons.default.EmojiPeopleIcon, link: `/admin/class-sessions`, children: null },
    { id: "audit-discussions", type: "link", category: "audit", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/discussions)\/?$/, /^(\/admin\/discussions)\/list\/?$/], active: true, permission: "auditing", label: "Discussions", icon: Icons.default.DiscussionsOutlined, activeIcon: Icons.default.Discussions, link: `/admin/discussions`, children: null },

    { id: "divider-audit", type: "divider", active: false, view: ["left-pannel"] },



    // { id: 15,type:"link", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [[/^(\/admin\/academic-rules)\/?$/, /^(\/admin\/academic-rules\/\w+)\/?$/, /^(\/admin\/academic-rule\/\d+\/checklist)\/?$/], [/^(\/admin\/academics\/auditors)\/?$/], [/^(\/admin\/academics\/audit)\/?$/]], active: false, permission: "academics", label: "Academics", activeIcon: Icons.default.School, icon: Icons.default.SchoolOutlined, link: [`/admin/academic-rules`, `/admin/academics/auditors`, `/admin/academics/audit`], children: ["Academic checklist", "Progress Auditors", "Audit"], childrenIcons: [{ default: Icons.default.RuleOutlined, activeIcon: Icons.default.Rule }, { default: Icons.default.AuditorOutlined, activeIcon: Icons.default.Auditor }, { default: Icons.default.InsightsIcon, activeIcon: Icons.default.InsightsIcon }] },
    // { id: 6, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [[/^(\/admin\/api-setting)\/?$/], [/^(\/admin\/feedback-setting)\/?$/], [/^(\/admin\/feedback)\/?$/], [/^(\/admin\/recordings)\/?$/]], active: false, permission: ["api_settings", "feedback", "feedback", "recordings"], label: "Online Classes", icon: Icons.default.VideocamIconOutlined, activeIcon: Icons.default.VideocamIcon, link: [`/admin/api-setting`, `/admin/feedback-setting`, `/admin/feedback`, `/admin/recordings`], children: ["API Settings", "Feedback Settings", "Feedback", "Recordings"], childrenIcons: [{ default: Icons.default.ApiOutlined, activeIcon: Icons.default.Api }, { default: Icons.default.SettingsOutlined, activeIcon: Icons.default.Settings }, { default: Icons.default.FeedbackIconOutlined, activeIcon: Icons.default.FeedbackIcon }, { default: Icons.default.FiberManualRecordIconOutlined, activeIcon: Icons.default.FiberManualRecordIcon }] },
    // { id: 8, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/attendance)\/?$/], active: false, permission: "attendance_audit", label: "Attendance Audit", icon: Icons.default.EmojiPeopleIconOutlined, activeIcon: Icons.default.EmojiPeopleIcon, link: `/admin/attendance`, children: null },
    // { id: 13, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/analytics)\/?$/], active: false, permission: "analytics", label: "Analytics", icon: Icons.default.AnalyticsIconOutlined, activeIcon: Icons.default.AnalyticsIcon, link: `/admin/analytics`, children: null },
    // { id: 9,view:["left-panel","opened-bottom-bar"], activeMatchRegexes: [/^(\/admin\/temporary-users)\/?$/], active: true, permission: "admin_permission", label: "Temporary Users", icon: Icons.default.TemporaryUsersOutlined, activeIcon: Icons.default.TemporaryUsers, link: `/admin/temporary-users`, children: null },
]

// Mobile layouts have no expandable groups, so a parent with children becomes one real link per child
const flattenMenuItem = ( item ) => {
    if ( !item.children ) return [item]
    return item.children.map( ( label, index ) => ( {
        ...item,
        id: `${item.id}-${index}`,
        label,
        link: item.link[index],
        activeMatchRegexes: item.activeMatchRegexes[index],
        icon: item.childrenIcons?.[index]?.default || item.icon,
        activeIcon: item.childrenIcons?.[index]?.activeIcon || item.activeIcon,
        children: null,
    } ) )
}

const CollapsedSubmenuFlyout = ( { item, active, onNavigate } ) => {
    const { palette } = useTheme()

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 180, py: 0.5 }}>
            <Typography noWrap sx={{ px: 1, pb: 0.5, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', color: palette.nav.font, opacity: 0.6 }}>{item.label}</Typography>
            {item.children.map( ( sublink, index ) => {
                const activeChild = item.activeMatchRegexes[index].some( re => active.match( re ) )
                return (
                    <Link className='default-link' key={sublink} to={item.link[index]} onClick={onNavigate}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            px: 1,
                            py: 0.5,
                            borderRadius: '5px',
                            fontSize: '14px',
                            color: activeChild ? palette.nav.activeFont : palette.nav.font,
                            background: activeChild ? palette.nav.activeSidebarItem : 'none',
                            '&:hover': { background: activeChild ? palette.nav.activeSidebarItem : palette.nav.sidebarItemHoverBg },
                        }}>
                            <Box sx={{ display: 'flex', fontSize: '16px' }}>{activeChild ? item.childrenIcons?.[index]?.activeIcon : item.childrenIcons?.[index]?.default}</Box>
                            <Typography noWrap sx={{ color: 'inherit', fontSize: 'inherit', fontWeight: activeChild ? 500 : 400 }}>{sublink}</Typography>
                        </Box>
                    </Link>
                )
            } )}
        </Box>
    )
}

const SidedrawerMenuItem = ( { item, isActive, sidebarOpenState, closeOnMobileScreen, active } ) => {

    const { isSideDrawerCollapsed } = useLayoutContext()
    const [collapseState, setCollapseState] = useState( false )
    const [flyoutOpen, setFlyoutOpen] = useState( false )
    const { palette, layout } = useTheme()

    const showFlyout = isSideDrawerCollapsed && !!item.children

    return (
        <Box sx={{ borderRadius: layout.borderRadius, bgcolor: collapseState && !isSideDrawerCollapsed && palette.nav.sidebarHover }}>
            <Tooltip
                placement={showFlyout ? 'right-start' : 'right'}
                enterDelay={0}
                disableInteractive={!showFlyout}
                arrow
                open={showFlyout ? flyoutOpen : undefined}
                onOpen={() => setFlyoutOpen( true )}
                onClose={() => setFlyoutOpen( false )}
                title={!isSideDrawerCollapsed ? '' : showFlyout ? <CollapsedSubmenuFlyout item={item} active={active} onNavigate={() => setFlyoutOpen( false )} /> : item.label}
                slotProps={showFlyout ? {
                    tooltip: { sx: { bgcolor: palette.nav.sidebar, color: palette.nav.font, border: `1px solid ${palette.divider}`, boxShadow: 3, p: 0.5, maxWidth: 'none', borderRadius: 2 } },
                    popper: { modifiers: [{ name: 'offset', options: { offset: [0, 5] } }] },
                } : undefined}
            >
                <Link className='default-link' target={item.target} to={!item.children ? ( typeof item.link === 'string' ? item.link : item.link() ) : `#${item.label}`}>
                    <Box
                        onClick={item.children ? () => !isSideDrawerCollapsed && setCollapseState( !collapseState ) : closeOnMobileScreen}
                        sx={{
                            color: isActive ? palette.nav.activeFont : palette.nav.font,
                            borderRadius: layout.borderRadius,
                            display: 'flex',
                            alignItems: 'center',
                            padding: 1,
                            paddingY: 0.5,
                            gap: '15px',
                            marginY: '2px',
                            minWidth: closedSidebarWidth - 20,
                            cursor: 'pointer',
                            position: 'relative',
                            background: isActive ? palette.nav.activeSidebarItem : 'none',
                            '&:hover': {
                                background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem,
                            },
                        }}
                    >
                        <Typography sx={{ color: 'inherit', padding: '2px', position: 'relative', fontSize: '18px', display: 'flex', alignItems: 'center' }}>
                            {item.icon}
                        </Typography>
                        <Box sx={{ flexGrow: 1, gap: '5px', justifyContent: 'space-between', display: 'flex', alignItems: 'center', flexShrink: 0, color: 'inherit', fontWeight: isActive ? '500' : '300', fontSize: '14px', textAlign: 'center' }}>
                            <Typography noWrap sx={{ display: 'flex', gap: '5px', alignItems: 'center', fontWeight: isActive ? '500' : '400', opacity: !isSideDrawerCollapsed ? 1 : 0, fontSize: '14px', color: 'inherit' }}>
                                {item.label}
                            </Typography>
                            <Box component='span' sx={{ color: palette.text.secondary }}>
                                {item.children && !isSideDrawerCollapsed ? Icons.small.KeyboardArrowDown : item.secondaryIcon || ''}
                            </Box>
                        </Box>
                    </Box>
                </Link>
            </Tooltip>
            {item.children && <Collapse in={collapseState && !isSideDrawerCollapsed}>
                <Box
                    sx={{
                        flexDirection: "column",
                        paddingBottom: "10px",
                        display: "flex",
                        gap: "5px",
                        paddingRight: "20px",
                        paddingLeft: "30px"
                    }}>
                    {item.children.map( ( sublink, index ) => {
                        const activeChild = item.activeMatchRegexes[index].some( re => active.match( re ) )
                        return (
                            <Link className='default-link' key={sublink} to={item.link[index]}>
                                <Box
                                    onClick={closeOnMobileScreen}
                                    sx={{
                                        display: "flex",
                                        borderRadius: "5px",
                                        padding: "2px 5px",
                                        gap: "20px",
                                        alignItems: "center",
                                        color: palette.nav.font,
                                        cursor: "pointer",
                                        position: "relative",
                                        fontWeight: activeChild ? 800 : 400,

                                        // "&::before": {
                                        //     display: activeChild ? "inline-block" : "none",
                                        //     content: "''",
                                        //     position: "absolute",
                                        //     background: "#fff",
                                        //     height: "60%",
                                        //     borderRadius: "0 2px 2px 0",
                                        //     left: 0,
                                        //     width: "2px",
                                        //     zIndex: 324434,
                                        //     top: "50%",
                                        //     transform: "translate(0,-50%)"
                                        // },

                                        "&:hover": {
                                            textDecoration: "underline",
                                        }
                                    }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            flexShrink: 0,
                                            color: "inherit",
                                            fontWeight: activeChild ? "400" : "300",
                                            fontSize: "14px",
                                            textAlign: "center"
                                        }}>{sublink}</Typography>
                                </Box>
                            </Link>
                        )
                    } )}
                </Box>
            </Collapse>}
        </Box>
    )
}

const SideDrawer = function ( { closeSideMenu } ) {

    const [menu, setMenu] = useState( [] )

    const { sidebarOpenState, setNavHeadText, active, menuState, setMenuState, sidebarWidth, minSidebarCollapseWidth, setIsSideDrawerCollapsed, isSideDrawerCollapsed } = useLayoutContext()

    const UserStore = useUserStore()

    const { palette, layout, shadows, border } = useTheme()
    const navigate = useNavigate()

    const closeOnMobileScreen = () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            closeSideMenu()
    }

    const toggleAuditMode = ( event ) => {
        event?.stopPropagation()
        if ( active.includes( '/audit' ) ) {
            let redirect = localStorage.getItem( 'audit_redirect' )
            if ( !redirect )
                redirect = ["ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) ? `/admin/home` : `/faculty/home`
            navigate( redirect )
        } else {
            localStorage.setItem( 'audit_redirect', `${active}${window.location.search}` )
            navigate( '/audit/' )
        }
        setMenuState( false )
    }

    const swipableDrawerMenuItems = useMemo( () => {

        const categoryMenuMap = {
            menuItems: {},
            categories: {}
        }
        for ( const item of menu ) {
            if ( !item.active || !item.view.includes( "opened-bottom-bar" ) ) continue
            if ( item.type === "category-header" ) {
                categoryMenuMap.categories[item.categoryValue] = item
            }
            else if ( item.type === "link" ) {
                if ( !categoryMenuMap.menuItems[item.category] )
                    categoryMenuMap.menuItems[item.category] = []
                categoryMenuMap.menuItems[item.category].push( ...flattenMenuItem( item ) )
            }

        }

        return categoryMenuMap
    }, [menu] )

    useEffect( () => {
        if ( UserStore.getUser.user_role.toLowerCase() !== 'admin' && UserStore.getUser.user_permissions ) {
            let menuList = []
            for ( let i = 0; i < allMenu.length; i++ ) {

                const menuItem = allMenu[i]
                if ( menuItem.type === 'divider' ) {
                    if ( menuList.length > 0 && menuList.at( -1 ).type !== 'divider' )
                        menuList.push( menuItem )
                    continue
                }
                if ( menuItem.type === 'category-header' ) {
                    const doesPermissionsForCateogyExists = allMenu.filter( item => item.category === menuItem.categoryValue && item.active && UserStore.getUser.user_permissions[item.permission] )
                    if ( doesPermissionsForCateogyExists.length > 0 )
                        menuList.push( menuItem )
                    continue
                }
                if ( menuItem.permission ) {
                    if ( UserStore.getUser.user_permissions[menuItem.permission] ) {
                        menuList.push( menuItem )
                    } else {
                        let dropDownMenu = undefined
                        for ( let j = 0; j < menuItem.permission.length; j++ ) {
                            const permission = menuItem.permission[j]
                            if ( UserStore.getUser.user_permissions[permission] ) {
                                if ( !dropDownMenu ) {
                                    dropDownMenu = { active: true, label: menuItem.label, icon: menuItem.icon, link: [], children: [] }
                                }
                                dropDownMenu.link.push( menuItem.link[j] )
                                dropDownMenu.children.push( menuItem.children[j] )
                            }
                        }
                        if ( dropDownMenu )
                            menuList.push( dropDownMenu )
                    }
                } else {
                    menuList.push( menuItem )
                }
                let bleedingItems = menuList.filter( item => item.view.includes( "bleeding-bottom-bar" ) ).length

                if ( bleedingItems < 3 ) {
                    for ( const item of menuList ) {
                        if ( !item.view.includes( "bleeding-bottom-bar" ) ) {
                            const openedBottomBarViewIndex = item.view.findIndex( view => view === 'opened-bottom-bar' )
                            if ( openedBottomBarViewIndex >= 0 )
                                item.view.splice( openedBottomBarViewIndex, 1 )
                            item.view.push( "bleeding-bottom-bar" )
                            bleedingItems += 1
                        }
                        if ( bleedingItems >= 3 )
                            break
                    }
                }
                setMenu( menuList )
            }
        } else {
            setMenu( allMenu )
        }
    }, [UserStore] )

    useEffect( () => {
        for ( let i = 0; i < allMenu.length; i++ ) {
            const item = allMenu[i]
            if ( item.type === 'divider' || item.type === 'category-header' ) continue
            const isActive = item.activeMatchRegexes.flat().some( re => active.match( re ) )
            if ( isActive ) {
                setNavHeadText( item.label )
                break
            }
        }
    }, [active, setNavHeadText] )


    return (
        <Box>
            <Box sx={{ display: { sm: 'block', xs: 'none' } }}>
                <Drawer
                    variant='persistent'
                    anchor='left'
                    open={true}
                    className='no-scrollbar'
                    slotProps={{
                        paper: {
                            className: 'no-scrollbar',
                            sx: {
                                width: !isSideDrawerCollapsed ? sidebarWidth : closedSidebarWidth,
                                borderRadius: '0',
                                background: palette.nav.sidebar,
                                borderRight: 'none',
                                transition: '200ms',
                                overflowX: 'hidden',
                            },
                        },
                    }}
                    sx={{ background: 'transparent', position: 'initial', overflow: 'hidden', width: !isSideDrawerCollapsed ? sidebarWidth : closedSidebarWidth, height: '100%', flexShrink: 0, display: { sm: 'flex', xs: 'none' }, flexDirection: 'column' }}
                >
                    <Box sx={{ position: 'relative', flexGrow: 1, overflow: 'hidden', display: 'flex' }}>
                        <Box className='sidebar-scrollbar' sx={{ display: 'flex', flexDirection: 'column', width: '100%', overflowX: 'clip', overflowY: 'auto', color: 'GrayText', alignItems: 'stretch' }}>
                            <Box sx={{ display: 'flex', gap: '10px', padding: '8px 15px', alignItems: 'center' }}>
                                <Box sx={{ padding: 0.7, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px', bgcolor: 'white', aspectRatio: '1 / 1' }}>
                                    <Box component='img' src={aliveLogo} alt='Logo' sx={{ width: '20px' }} />
                                </Box>
                                <Box sx={{ opacity: !isSideDrawerCollapsed ? 1 : 0 }}>
                                    <Typography variant='h6' sx={{ color: palette.nav.font, fontSize: '14px' }}>Alive</Typography>
                                    <Typography variant='body2' noWrap sx={{ color: palette.nav.font, fontSize: '12px', fontWeight: '300' }}>Acharya LMS platform</Typography>
                                </Box>
                                <IconButton sx={{ color: palette.nav.font, display: { sm: 'none', xs: 'block' } }} onClick={() => setMenuState( false )}>
                                    {Icons.default.CloseIcon}
                                </IconButton>
                            </Box>
                            <Box className='sidebar-scrollbar' sx={{ padding: '0 10px 0 10px', flexGrow: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto', overflowX: 'clip' }}>
                                {menu.filter( item => item.active ).map( item => {

                                    if ( item.type === 'divider' )
                                        return <Divider sx={{ background: palette.grey[500] }} key={item.id} />
                                    if ( item.type === 'category-header' )
                                        return <Typography key={item.id} color='textSecondary' component='span' sx={{ textTransform: 'uppercase', fontSize: '10px', mb: 0.5, mt: 2, display: 'block', letterSpacing: '1px', opacity: isSideDrawerCollapsed ? 0 : 1, maxHeight: isSideDrawerCollapsed ? '0' : 'auto' }}>{item.label}</Typography>

                                    const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                    return (
                                        <SidedrawerMenuItem active={active} closeOnMobileScreen={closeOnMobileScreen} item={item} isActive={isActive} sidebarOpenState={sidebarOpenState} key={item.id} />
                                    )
                                } )}
                                <Box sx={{ flexGrow: 1 }} />
                                <Box sx={{ mt: 2, py: 2, borderTop: border[1], minWidth: 0, position: "sticky", bottom: 0, background: palette.nav.sidebar, overflow: "visible", "::before": { content: `''`, position: "absolute", bottom: "100%", height: "40px", width: "100%", pointerEvents: "none", background: `linear-gradient(to top, ${palette.nav.sidebar}, transparent)` } }}>
                                    <EcosystemPortalCard isSideDrawerCollapsed={isSideDrawerCollapsed} />
                                    <Box onClick={() => setIsSideDrawerCollapsed( prev => !prev )} sx={{ color: palette.nav.font, borderRadius: layout.borderRadius, display: 'flex', alignItems: 'center', padding: 1, paddingY: 0.5, gap: '15px', marginY: '2px', minWidth: closedSidebarWidth - 20, cursor: 'pointer', position: 'relative', background: 'none', '&:hover': { background: palette.nav.sidebarItemHoverBg } }}>
                                        <Tooltip placement='right' enterDelay={0} disableInteractive arrow title={!isSideDrawerCollapsed ? '' : 'Expand Sidebar'}>
                                            <IconButton color='inherit' disableFocusRipple disableRipple disableTouchRipple sx={{ padding: '2px', borderRadius: '5px', transform: 'scale(0.9)', position: 'relative', fontSize: '18px' }}>
                                                {!isSideDrawerCollapsed ? Icons.default.MenuClose : Icons.default.ChevronRightIcon}
                                            </IconButton>
                                        </Tooltip>
                                        <Typography noWrap sx={{ opacity: !isSideDrawerCollapsed ? 1 : 0, fontSize: '0.875rem' }}>Collapse Sidebar</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Drawer>
            </Box>
            <Box sx={{ display: { sm: 'none', xs: 'block' } }}>
                <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'space-evenly', padding: '10px 20px', background: palette.layoutBackground }}>
                    {menu.filter( item => item.active && item.view.includes( "bleeding-bottom-bar" ) ).flatMap( flattenMenuItem ).map( item => {

                        if ( item.type === 'divider' ) return ''
                        if ( item.type === 'category-header' ) return ''

                        const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                        return (
                            <Box key={item.id}>
                                <Link to={item.link} className='default-link' >
                                    <Box sx={{ py: 1, color: palette.nav.font, display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px' }}>
                                        <Box sx={{ background: isActive ? palette.nav.activeSidebarItem : 'none', fontSize: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 1, borderRadius: 10, color: isActive ? palette.nav.activeFont : palette.nav.font, '&:hover': { background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem } }}>{item.icon}</Box>
                                        <Typography sx={{ color: 'inherit', fontSize: '12px', textAlign: 'center' }}>{item.label}</Typography>
                                    </Box>
                                </Link>
                            </Box>
                        )
                    } )}
                    {( menu.length > 3 || ( ["PRINCIPAL", "HOD", "ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) || UserStore.getUser.user_auditor ) ) && <Box sx={{ color: palette.nav.font, display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px', cursor: 'pointer' }} onClick={() => setMenuState( true )}>
                        <Box sx={{ color: 'inherit', p: 1, fontSize: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{Icons.default.Menu}</Box>
                        <Typography sx={{ color: 'inherit', fontSize: '12px', textAlign: 'center' }}>More</Typography>
                    </Box>}
                </Box>


                <SwipeableDrawer
                    sx={{ background: "transparent", zIndex: { sm: "initial", xs: "120000" }, overflow: "hidden", width: menuState ? sidebarWidth : 0, flexSrink: 0, display: { xs: "flex", sm: "none" }, flexDirection: "column" }}
                    anchor="bottom"
                    open={menuState}
                    className="no-scrollbar"
                    keepMounted={false}
                    swipeAreaWidth={0}
                    onClose={() => setMenuState( false )}
                    onOpen={() => setMenuState( true )}
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { borderRadius: `${layout.borderRadius * 4 + "px"} ${layout.borderRadius * 4 + "px"} 0 0`, background: palette.nav.sidebar, borderRight: "none", maxHeight: "80%" } }
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            overflow: "auto"
                        }}>
                        {( ["PRINCIPAL", "HOD", "ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) || UserStore.getUser.user_auditor ) && <Box
                            onClick={toggleAuditMode}
                            sx={{
                                display: { xs: "flex", md: "none" },
                                gap: "10px",
                                alignItems: "center",
                                justifyContent: "space-between",
                                margin: "20px",
                                padding: "5px 10px",
                                boxShadow: shadows[1],
                                bgcolor: palette.contentBg,
                                border: border[1],
                                borderRadius: "10px",
                                cursor: "pointer"
                            }}>
                            <Typography color={palette.common.font} variant="subtitle2" sx={{
                                fontSize: "12px"
                            }}>Audit Mode</Typography>
                            <CustomSwitch size="small" checked={active.startsWith( '/audit' )} onChange={toggleAuditMode} />
                        </Box>}
                        {Object.keys( swipableDrawerMenuItems?.categories || {} ).length > 0 && <Box
                            sx={{
                                flexGrow: 1,
                                overflow: "auto"
                            }}>
                            {Object.keys( swipableDrawerMenuItems?.categories || {} ).map( category => {
                                const menuItems = swipableDrawerMenuItems.menuItems[category]
                                return (
                                    <Box key={category}>
                                        <Typography
                                            color={palette.nav.font + "99"}
                                            gutterBottom
                                            component="span"
                                            sx={{
                                                textTransform: "uppercase",
                                                fontSize: "10px",
                                                margin: "20px 0 0 20px",
                                                display: "block",
                                                letterSpacing: "1px"
                                            }}>{swipableDrawerMenuItems.categories[category].label}</Typography>
                                        <Box
                                            className="sidebar-scrollbar"
                                            sx={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(3,1fr)",
                                                padding: "40px 20px",
                                                flexWrap: "wrap",
                                                width: "100%",
                                                gap: "30px",
                                                justifyContent: "space-evenly",
                                                overflow: "auto",
                                                color: "GrayText",
                                                alignItems: "stretch"
                                            }}>
                                            {menuItems.map( item => {
                                                const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                                return (
                                                    <Box key={item.id}>
                                                        <Link onClick={() => setMenuState( false )} to={item.link} className='default-link' >
                                                            <Box
                                                                sx={{
                                                                    color: palette.nav.font,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    flexDirection: "column",
                                                                    gap: "5px"
                                                                }}>
                                                                <Box sx={{ background: isActive ? palette.nav.activeSidebarItem : "none", color: isActive ? palette.nav.activeFont : palette.nav.font, fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px", borderRadius: 10, "&:hover": { background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem } }}>{item.icon}</Box>
                                                                <Typography
                                                                    sx={{
                                                                        color: "inherit",
                                                                        fontSize: "12px",
                                                                        textAlign: "center"
                                                                    }}>{item.label}</Typography>
                                                            </Box>
                                                        </Link>
                                                    </Box>
                                                )
                                            } )}
                                        </Box>
                                    </Box>
                                )
                            } )}
                        </Box>}
                    </Box >
                </SwipeableDrawer >
            </Box>
        </Box >
    )
}

export default SideDrawer



// import DashboardIcon from '@mui/icons-material/Dashboard'
// import SchoolIcon from '@mui/icons-material/School'
// import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
// import EventIcon from '@mui/icons-material/Event'
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
// import MessageIcon from '@mui/icons-material/Message'
// import NotificationsIcon from '@mui/icons-material/Notifications'